/**
 * 短信服务
 */
import CommonApi from 'api/common.js';
var url = '/dayaotex-server-sms/megCode';
var SmsApi = {
  /**
   * 发送短信
   * @param mobile 手机号码
   * @returns {Promise}
   */
  sendCode: function sendCode(data) {
    return CommonApi.post(url + '/sendMegCodeSMS', data);
  },
  //短信验证码=====
  sendSMSLoginCode: function sendSMSLoginCode(data) {
    return CommonApi.post(url + '/sendSMSLoginCode', data);
  }
};
export default SmsApi;